import { INGREDIENT_UNITS } from "../../constant/constants";

export function getInventoryListTableData(data, removes = []) {
  const tableData = [];
  if (!Array.isArray(data) && data.length < 1) return;
  data.map((item) => {
    const rest = { ...item };
    removes.forEach((prop) => {
      delete rest[prop];
    });
    tableData.push(rest);
  });

  return tableData;
}

export function isValidMobileNo(number) {
  if (!number || number.length === 0) return;
  const localRegex = /^01[3-9]\d{8}$/;
  const intlRegex = /^\+8801[3-9]\d{8}$/;

  return localRegex.test(number) || intlRegex.test(number);
}

export function prepareDropdown(data, labelProp, valueProp) {
  if (!Array.isArray(data) || data.length < 1) return;
  if (!Boolean(labelProp) || !Boolean(valueProp)) return;

  return data.map((item) => ({ label: item[labelProp], value: item[valueProp] }));
}

export function getUnitFromSelectedIngredient(ingredients, ingredientId) {
  if (!Array.isArray(ingredients) || !Boolean(ingredientId)) return;
  const currentUnit = ingredients.find((item) => item.id === ingredientId).baseUnit || "";
  return currentUnit;
}

export function getIngredientUnitLabel(unitValue) {
  if (!Boolean(unitValue)) return;
  return INGREDIENT_UNITS.find((item) => item.value === unitValue).label;
}

export function convertDateToLocale(isoDateString) {
  if (!isoDateString) return;
  const date = new Date(isoDateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", {
    month: "long",
  });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

function formatFileName(fname) {
  const date = new Date(Date.now());
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");

  const name = fname.split(".")[0];
  const ext = fname.split(".")[1];
  return `${name}-${year}-${month}-${day}.${ext}`;
}

export function downloadPDF(blob, filename) {
  try {
    const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = formatFileName(filename);
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download error:", error);
  }
}

export function checkItemTitle(name) {
  const VALID_TITLE_REGEX = /^[A-Za-z][A-Za-z0-9 ,()\/'\"&:+.]*$/;

  if (typeof name !== "string") return false;
  if (name.trim() === "") return false;
  return VALID_TITLE_REGEX.test(name);
}
